import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CancelHandler } from '@app/store/modal/modal.classes';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
})
export class ModalHeaderComponent implements OnInit {
  @Input() outletName = 'modal';
  @Output() onCloseChange = new EventEmitter<void>();

  constructor(
    private router: Router,
    private store: Store
  ) {
  }

  ngOnInit(): void { }

  onClose(): void {
    this.router.navigate(['', { outlets: { [this.outletName]: null } }], { queryParamsHandling: 'preserve' });
    this.onCloseChange.emit();
    this.store.dispatch(new CancelHandler);
  }
}
